import { authFetch } from "lib/api/authFetch";

function getFilenameFromDisposition(disposition) {
  if (!disposition) return "";

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].replace(/"/g, ""));
    } catch {
      return utf8Match[1].replace(/"/g, "");
    }
  }

  const plainMatch = disposition.match(/filename="?([^"]+)"?/i);
  if (!plainMatch?.[1]) return "";

  try {
    return decodeURIComponent(plainMatch[1]);
  } catch {
    return plainMatch[1];
  }
}

export async function downloadAdminFile(streamUrl, filename = "") {
  if (!streamUrl) {
    return { success: false, message: "다운로드 URL이 없습니다." };
  }

  const response = await authFetch(
    streamUrl,
    { method: "GET" },
    { refreshUrlIncludes: "auth/refresh" },
  );

  if (!response.ok) {
    let message = "파일 다운로드에 실패했습니다.";
    try {
      const result = await response.json();
      message = result?.message || message;
    } catch {}
    return { success: false, message };
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const dispositionName = getFilenameFromDisposition(
    response.headers.get("Content-Disposition"),
  );

  link.href = objectUrl;
  link.download = filename || dispositionName || "download.ud";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);

  return { success: true };
}
